"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTitle = setTitle;
exports.resetTitle = resetTitle;
exports.withDocumentTitle = withDocumentTitle;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

function setTitle(title) {
  document.title = _I18n.default.text("pricingPage.windowTitles." + title);
}

function resetTitle() {
  setTitle('default');
}

function withDocumentTitle(WrappedComponent, title) {
  return function (props) {
    (0, _react.useEffect)(function () {
      setTitle(title);
      return function () {
        return resetTitle();
      };
    }, []);
    return _react.default.createElement(WrappedComponent, props);
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/utils/DocumentUtils.js
// module id = 140
// module chunks = 5 6